<template>
  <div class="g-container-p">
    <div class="m-container-p">
      <!-- 面包屑 -->
      <div>
        <h3>
          <slot name="title"></slot>
        </h3>
        <slot name="remark"></slot>
        <div v-if="isImg">
          <div class="demo-image">
            <div class="block"
                 v-for="(url,index) of picDataArr"
                 :key="index">
              <el-image style="width: 200px; height: 200px"
                        :src="url"
                        :fit="'scale-down'"
                        :preview-src-list="picDataArr"></el-image>
            </div>
          </div>
        </div>
        <div v-if="isPdf">
          <div v-if="getPDFShow">
            <el-link :href="oldExtraFile"
                     target="_blank"
                     type="primary">现场基础情况检查告知函</el-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "../../../../../html/pages/originality/createTestReport/createTestReport.scss"

import imageUpload from "../../../../../components/imageUpload/qeImageUpload"

export default {
  name: 'updateQeUploadFile',
  props: ['basePicArr', 'baseFileType', 'oldExtraFile'],
  watch: {
    basePicArr (newValue) {
      this.picDataArr = newValue;
      //   console.log("basePicArr", newValue)
      //   console.log("basePicArr", this.picDataArr)
    },
    baseFileType (newValue) {
      //console.log("baseFileType", newValue)
      if ("IMG" == newValue) {
        this.isImg = true
        this.isPdf = false
      } else {
        this.isImg = false
        this.isPdf = true
      }
    }
  },
  data () {
    return {
      reportData: {
        id: this.$route.params.id,
        DetName: "",
        DetId: "",
        ImgUrl: [],
        PdfUrl: ""
      },
      picDataArr: this.basePicArr,//原图
      thumPicDataArr: [],//压缩图
      titleText: "",
      type: "",
      JointWarranty: [],//验收单
      extraData: {
        type: 'file',
        file: ''
      },
      isImg: false,
      isPdf: true,
    }
  },
  components: {
    imageUpload,
  },
  computed: {
    getPDFShow () {
      if (this.oldExtraFile && this.oldExtraFile.trim() !== '') {
        return true
      }
      return false
    },
  },
  methods: {

    async uploadReprot (fn) {

    },
    beforeRouteUpdate (to, from, next) {
      next();
      this.picDataArr = []
      this.thumPicDataArr = []
    },
    reload () {
      this.uploadReprot(item => {
        window.location.reload()
      })
    },
  },
}
</script>

<style scoped>
.demo-image {
  width: 60%;
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  justify-content: flex-start;
  align-items: flex-start;
}

.block {
  flex: 0 0 auto;
}
</style>
